import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { useContext, useState } from 'react';
import UserProfile from './UserProfile';
import BillingPage from './BillingPage';
import { UserContext } from '../Context/UserContext';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import { sentryLog } from '../Utils/SentryLog';
import { getLqzyParams } from '../Utils/GetLqzyParams';
import ExtensionNavbar from './ExtensionNavbar';
import SlidesExtensionNavbar from './SlidesExtensionNavbar';
import SlidesUserProfile from './SlidesUserProfile';
import SlidesBillingPage from './SlidesBillingPage';

const lemonSqzyQueryParams = getLqzyParams();

function SlidesExtensionUserAccount({isIndianUser}){

    const [category, setCategory] = useState("profile");
    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const { user } = useContext(UserContext);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    const navigate = useNavigate();

    isShowConsole && console.log('user account user check ssrk: ', user);
    isShowConsole && console.log("Current Path:", location.pathname); 

    const API_BASE_URL = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL;

    const initiateLogout = e => {
        try{
            window.location.href = `${API_BASE_URL}/auth/logout`;
        }catch(err){
            isShowConsole && console.error('error in initiate logout method: ', err);
            sentryLog(`SlidesExtensionUserAccount.js - initiateLogout failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }

    const handleHelp = e => {
        try{
            navigate(`/slides-extension-contact-us${lemonSqzyQueryParams}`);
        }catch(err){
            isShowConsole && console.error('error in handle help method: ', err);
            sentryLog(`SlidesExtensionUserAccount.js - handleHelp failed: ${err?.message || err} | user: ${JSON.stringify(user)}`);
        }
    }
    
    return(
        <div className='parentDiv'>
            <div className='mainDiv userAccount'>
                <div className='header'>
                    <SlidesExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Account Information</div>
                        <div className='contentBox'>
                            <div className='content'>
                                <div className='lhs'>
                                    <div className='container'>
                                        <div className='top-section'>
                                            <div className={`category ${category === 'profile' ? 'selected' : ''}`} onClick={() => setCategory("profile")}>Profile Details</div>
                                            <div className={`category ${category === 'billing' ? 'selected' : ''}`} onClick={() => setCategory("billing")}>Billing Details</div>
                                        </div>
                                        <div className='bottom-section'>
                                            <div className='category' onClick={handleHelp}>Need Help ?</div>
                                            {/* <div className='category' onClick={initiateLogout}>Logout</div> */}
                                        </div>
                                    </div>
                                </div>
                                {user && <div className='rhs'>
                                    {category === 'profile' ? <SlidesUserProfile userDetails={user}/> : category === "billing" ? <SlidesBillingPage isIndianUser={isIndianUser} userDetails={user}/> : ""}
                                    <div className='userInfoNote'><b>NOTE:</b> These account details apply only to the Google Slides Extension <b>Convert PDF to Google Slides™</b></div>
                                </div>}
                                <div className='mobileBottomSection'>
                                    <div className='container'>
                                        <div className='category' onClick={handleHelp}>Need Help ?</div>
                                        {/* <div className='category' onClick={initiateLogout}>Logout</div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default SlidesExtensionUserAccount;